//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('activityGrid', {
//        templateUrl: 'views/components/views/activityGrid/activityGrid.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'activityGridService', 'logisticService', 'ttGridFactory', 'typeaheadService', 'rememberService', function ($stateParams, stateService, utilityService, activityGridService, logisticService, ttGridFactory, typeaheadService, rememberService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let argType = $stateParams.argtype;
//            let argValue = $stateParams.argvalue;

//            let variableNames = {
//                businessco_no: '',
//                ok: ''
//            };

//            vm.model = {
//                gridReady: false,
//                setting: {},
//                selectListOks: [],
//                selectListBusinessCompanies: []
//            };

//            vm.grid = new ttGridFactory({
//                rememberId: '',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            }).setToolbar({ wrapping: true });

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadSetting() {
//                vm.model.setting = (await activityGridService.getActivityGrid({
//                    argtype: argType,
//                    argvalue: argValue
//                }))[0];
//            }

//            async function loadCompanies() {
//                vm.model.selectListBusinessCompanies = await logisticService.listCompanies();
//            }

//            async function loadOks() {
//                vm.model.selectListOks = await activityGridService.listOks();
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region GRID PROCEDURE FUNCTION CALLS

//            async function loadGrid() {
//                if (utilityService.validateParmsValue(vm.model.setting.view_id) === true) {
//                    vm.grid.dataTask.rememberId = vm.model.setting.view_id;
//                }

//                if (utilityService.validateParmsValue(vm.model.setting.p2_datatask_keyno) === true) {
//                    vm.grid.dataTask.loadData = {
//                        method: vm.model.setting.p2_datatask_keyno,
//                        parameters: vm.model.setting
//                    };

//                    vm.model.gridReady = true;

//                    if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
//                }
//            }

//            // #endregion GRID PROCEDURE FUNCTION CALLS

//            // #region TYPEAHEAD SEARCH SINGLE PROCEDURE FUNCTION CALL

//            vm.typeaheadSearch = function (value, id) {
//                switch (id) {
//                    case 'cust_name':
//                        vm.model.setting[id] = value;

//                        return typeaheadService.searchCustomer({
//                            cust_name: vm.model.setting[id] || '',
//                            filtertype: '',
//                            filtervalue: '',
//                            custtype: 'C',
//                            lastselect: 'SEARCH'
//                        });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion TYPEAHEAD SEARCH SINGLE PROCEDURE FUNCTION CALL

//            // #region SELECTED VALUE FUNCTION

//            vm.onTypeaheadSelected = function (item, id) {
//                switch (id) {
//                    case 'cust_name':
//                        if (item) {
//                            vm.model.setting.cust_no = item?.item_id ?? '0';
//                            vm.model.setting.cust_name = item?.item_name ?? '';
//                        } else {
//                            vm.onTypeaheadClear('cust_name');
//                        }

//                        loadGrid();
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion SELECTED VALUE FUNCTION

//            // #region CHANGED VALUE FUNCTION

//            vm.onTypeaheadChanged = function (value, item, id) {
//                switch (id) {
//                    case 'cust_name':
//                        vm.model.setting.cust_name = value;

//                        if (value) {
//                            if (item?.item_id) {
//                                vm.model.setting.cust_no = item.item_id;
//                            }
//                        } else {
//                            vm.onTypeaheadClear('cust_name');
//                            loadGrid();
//                        }
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion CHANGED VALUE FUNCTION

//            // #region CLEAR VALUE FUNCTION

//            vm.onTypeaheadClear = function (id) {
//                switch (id) {
//                    case 'cust_name':
//                        vm.model.setting.cust_no = '0';
//                        vm.model.setting.cust_name = '';
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion CLEAR VALUE FUNCTION

//            // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            function rememberFunc(id) {
//                Object.keys(variableNames).forEach((key) => {
//                    switch (key) {
//                        case '':
//                            break;
//                        default:
//                            variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
//                            break;
//                    }
//                });

//                if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

//                let variableValue = null;

//                switch (id) {
//                    case 'businessco_no':
//                    case 'ok':
//                        if (utilityService.validateParmsValue(vm.model.setting[id]) !== true) return;

//                        variableValue = vm.model.setting[id];
//                        break;
//                    default:
//                        break;
//                }

//                return rememberService.remember(variableNames[id], variableValue);
//            }

//            // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            // #region FIELD CHANGE MULTI FUNCTIONS

//            vm.onChanged = async function (value, id) {
//                switch (id) {
//                    case 'businessco_no':
//                    case 'ok':
//                        if (utilityService.validateWatchValue(value, vm.model.setting[id]) !== true) return;

//                        vm.model.setting[id] = value;

//                        if (utilityService.validateParmsValue(vm.model.setting[id]) !== true) return;

//                        rememberFunc(id);
//                        await loadGrid();
//                        break;
//                    default:
//                        utilityService.setValueToVariable(value);
//                        break;
//                }
//            };

//            // #endregion FIELD CHANGE MULTI FUNCTIONS

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state) {
//                switch (state) {
//                    case 'custactedit1':
//                        stateService.go('custactedit', {
//                            custact_no: '0',
//                            filterfield: '-',
//                            filtervalue: '-'
//                        });

//                        break;
//                    case 'custactedit2':
//                        stateService.go('custactedit', {
//                            custact_no: '0',
//                            filterfield: 'cust_no',
//                            filtervalue: vm.model.setting.cust_no
//                        });

//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                await loadSetting();
//                loadCompanies();
//                loadOks();
//                loadGrid();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
